import { StorageMaintenanceState } from "@/models/storageMaintenance/interfaces/storageMaintenance";

export const updateUserSelectionsStorage = (state: StorageMaintenanceState) => {
  state.userSelectionsStorage = Date.now();
};
export const updateIWSettingsTimeStamp = state => {
  state.iwSettingsTimeStamp = Date.now();
};
export const updateVenueTimeStamp = state => {
  state.venueTimeStamp = Date.now();
};
export const updateVendorTimeStamp = state => {
  state.vendorTimeStamp = Date.now();
};
export const updateItemsTimeStamp = state => {
  state.itemsTimeStamp = Date.now();
};
